module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00351.0b38bd10.jpg";